import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from '@nerdwallet/currency';
import nds from '@nerdwallet/base-styles/classes';

const DrawerToggle = ({ className, isExpanded, toggleExpanded }) => (
  <div
    className={classNames([
      nds('text-align-center', 'padding-all-3'),
      className,
    ])}
    data-integration="drawer-toggle"
  >
    <Link onClick={toggleExpanded} bold uppercase size={1}>
      {isExpanded ? 'Hide Details' : 'Show Details'}
    </Link>
  </div>
);

DrawerToggle.propTypes = {
  className: PropTypes.string,
  isExpanded: PropTypes.bool.isRequired,
  toggleExpanded: PropTypes.func.isRequired,
};

DrawerToggle.defaultProps = {
  className: '',
};

export default DrawerToggle;
